import type { Theme } from './themes';
import { defaultTheme } from './themes';
import './global.css';
import { ThemeContext } from './ThemeContext';
import { appendStylesheet } from './appendStylesheet';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import { getFontUrl } from './getFontUrl';
import { getFontFamily } from './getFontFamily';

type ThemeProviderProps = {
  theme?: Theme;
  children: React.ReactNode;
};

export const ThemeProvider = ({ theme, children }: ThemeProviderProps) => {
  appendStylesheet(getFontUrl(theme?.font));

  const appliedTheme = Object.assign({}, defaultTheme, omitBy(theme, isNil));

  const themeStyle: Record<string, string | number | undefined> = {
    '--experience-background-color': appliedTheme.experienceBackgroundColor,
    '--experience-border': appliedTheme.experienceBorder,
    '--experience-padding': appliedTheme.experiencePadding,
    '--experience-text-alignment': appliedTheme.experienceTextAlignment,
    '--primary-color': appliedTheme.primaryColor,
    '--secondary-color': appliedTheme.secondaryColor,
    '--error-color': appliedTheme.errorColor,
    '--font-family': `'${getFontFamily(appliedTheme.font)}', sans-serif`,
  };

  return (
    <ThemeContext.Provider value={appliedTheme}>
      <div style={themeStyle}>{children}</div>
    </ThemeContext.Provider>
  );
};
